import Client from "@/http/client";
import {
  SupportAdvertisementClickListDto,
  SupportAdvertisementDto,
  SupportAdvertisementListDto,
  SupportAdvertisementSaveDto,
} from "@/http/dto/supportAdvertisement";

export class SupportAdvertisements {
  static async getAdvertisements(params: {
    page: number;
    take: number;
    area?: string;
    status?: string;
    keyword?: string;
  }) {
    return await Client.get<SupportAdvertisementListDto>(
      "/v2/supporter/advertisements",
      params,
    );
  }

  static async getAdvertisement(objectId: string) {
    return await Client.get<SupportAdvertisementDto>(
      `/v2/supporter/advertisements/${objectId}`,
    );
  }

  static async create(saveDto: SupportAdvertisementSaveDto) {
    return await Client.post<SupportAdvertisementDto>(
      "/v2/supporter/advertisements",
      saveDto,
    );
  }

  static async update(objectId: string, saveDto: SupportAdvertisementSaveDto) {
    return await Client.put<SupportAdvertisementDto>(
      `/v2/supporter/advertisements/${objectId}`,
      saveDto,
    );
  }

  static async delete(objectId: string) {
    return await Client.del(`/v2/supporter/advertisements/${objectId}`);
  }

  static async getClicks(objectId: string, params: { page: number; take: number }) {
    return await Client.get<SupportAdvertisementClickListDto>(
      `/v2/supporter/advertisements/${objectId}/clicks`,
      params,
    );
  }
}
